import type { useForm } from 'vee-validate'
import type { ReactiveMember } from '~~/types/ReactiveMember'

export const useCommonMemberFields = (defineField: ReturnType<typeof useForm>['defineField'], validateField: ReturnType<typeof useForm>['validateField']) => {
	const [firstname, firstnameAttrs] = useDebouncedField('firstname', defineField, validateField)
	const [lastname, lastnameAttrs] = useDebouncedField('lastname', defineField, validateField)
	const [birthday, birthdayAttrs] = useDebouncedField('birthday', defineField, validateField)
	const [gender, genderAttrs] = useDebouncedField('gender', defineField, validateField)
	const [iban, ibanAttrs] = useDebouncedField('iban', defineField, validateField)
	const [joinDate, joinDateAttrs] = useDebouncedField('joinDate', defineField, validateField)
	const [street, streetAttrs] = useDebouncedField('contactInformation.address.street', defineField, validateField)
	const [houseNumber, houseNumberAttrs] = useDebouncedField('contactInformation.address.houseNumber', defineField, validateField)
	const [postalCode, postalCodeAttrs] = useDebouncedField('contactInformation.address.postalCode', defineField, validateField)
	const [city, cityAttrs] = useDebouncedField('contactInformation.address.city', defineField, validateField)
	const [phone, phoneAttrs] = useDebouncedField('contactInformation.phone', defineField, validateField)
	const [email, emailAttrs] = useDebouncedField('contactInformation.email', defineField, validateField)
	const [tags, tagsAttrs] = useDebouncedField('tags', defineField, validateField)

	return {
		firstname,
		firstnameAttrs,
		lastname,
		lastnameAttrs,
		birthday,
		birthdayAttrs,
		gender,
		genderAttrs,
		iban,
		ibanAttrs,
		joinDate,
		joinDateAttrs,
		street,
		streetAttrs,
		houseNumber,
		houseNumberAttrs,
		postalCode,
		postalCodeAttrs,
		city,
		cityAttrs,
		phone,
		phoneAttrs,
		email,
		emailAttrs,
		tags,
		tagsAttrs,
	} as ReactiveMember
}
